import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchFellowShipBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-our-training-fellowship-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFellowShipTestimonials = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-our-training-fellowship-testimonials?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchObserverShipBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-our-training-observership-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};
